import React from 'react'

export default ({ card, onClick }) => (
  <button
    onClick={() => onClick(card)}
    className="w-full bg-white border border-gray-200 rounded-lg p-3 hover:border-primary-500 hover:shadow-md transition-all duration-200 text-center group"
  >
    <svg
      className="w-5 h-5 text-gray-400 group-hover:text-primary-600 mx-auto mb-2"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5zm6-10.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm1.294 6.336a6.721 6.721 0 01-3.17.789 6.721 6.721 0 01-3.168-.789 3.376 3.376 0 016.338 0z"
      />
    </svg>
    <span className="text-gray-900 font-medium text-sm">{card.name}</span>
  </button>
)
